import {
  Card,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Typography,
  Stack,
  useTheme,
} from "@mui/material";
import { CheckCircle } from "@mui/icons-material";
import type { PendingJobOut } from "@providers/hop-ord-server/api";

interface PendingJobsTableProps {
  pendingJobs: PendingJobOut[];
}

export const PendingJobsTable = ({ pendingJobs }: PendingJobsTableProps) => {
  const theme = useTheme();

  const tableStyles = {
    "& .MuiTableCell-head": { padding: 2 },
    "& .MuiTableCell-body": {
      padding: 1,
      borderRight: `1px solid ${theme.palette.divider}`,
    },
  };

  const containerStyles = {
    maxHeight: "400px",
    overflow: "auto",
  };

  return (
    <Card>
      <TableContainer sx={containerStyles}>
        <Table stickyHeader size="small" sx={tableStyles}>
          <TableHead>
            <TableRow>
              <TableCell>Stream</TableCell>
              <TableCell>Group</TableCell>
              <TableCell align="right">Pending Count</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {pendingJobs.length === 0 ? (
              <TableRow>
                <TableCell colSpan={3} sx={{ border: "none !important" }}>
                  <Stack
                    direction="row"
                    alignItems="center"
                    gap={1}
                    padding={2}
                    sx={{
                      backgroundColor: theme.palette.success.light,
                      borderRadius: 1,
                    }}
                  >
                    <CheckCircle color="success" />
                    <Typography>No jobs currently in progress</Typography>
                  </Stack>
                </TableCell>
              </TableRow>
            ) : (
              pendingJobs.map((job, index) => (
                <TableRow
                  key={`${job.groupName}-${job.streamName}-${index}`}
                  sx={{
                    backgroundColor:
                      job.pendingCount > 0
                        ? theme.palette.warning.light
                        : "inherit",
                  }}
                >
                  <TableCell>{job.streamName}</TableCell>
                  <TableCell>{job.groupName}</TableCell>
                  <TableCell align="right">
                    {job.pendingCount > 0 ? (
                      <Typography color="warning.main" fontWeight="bold">
                        {job.pendingCount}
                      </Typography>
                    ) : (
                      job.pendingCount
                    )}
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Card>
  );
};
